export const ASSIGNEE_FILTER_PREFIX = "member-"

/**
 * Convert an array of assignee IDs to an array of assignee filters
 * @param assigneeIds - The array of assignee IDs to convert
 * @returns The array of assignee filters
 * @example convertAssigneeIdsToFilters(["1", "2"]) // ["member-1", "member-2"]
 */
export function convertAssigneeIdsToFilters(assigneeIds: string[]) {
  return assigneeIds.map((id) => `${ASSIGNEE_FILTER_PREFIX}${id}`)
}
